// src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { loginUser, getMe } from '../../api/user'; // you need a "whoami" API function
import apiClient from '../../api/apiClient'; // your axios instance

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Restore session on page load
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await apiClient.get("/me/"); // call your "whoami" endpoint
        setUser(res.data);
      } catch (err) {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  const login = async (username, password) => {
    try {
      const res = await apiClient.post("/login_landing/", { username, password });
      setUser(res.data);
    } catch (err) {
      console.error("Login failed", err);
      throw err;
    }
  };

  const logout = async () => {
    try {
      await apiClient.post("/logout_landing/");
      setUser(null);
    } catch (err) {
      console.error("Logout failed", err);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
